/**
 * Action types for docker registry functionality.
 *
 * These constants are typically used in Redux action creators and reducers to handle list of docker registry.
 */

// Get docker registry constants
export const DOCKER_REGISTRY_REQUEST_GET = 'DOCKER_REGISTRY_REQUEST_GET';
export const DOCKER_REGISTRY_RESPONSE_GET_SUCCESS = 'DOCKER_REGISTRY_RESPONSE_GET_SUCCESS';
export const DOCKER_REGISTRY_RESPONSE_GET_FAIL = 'DOCKER_REGISTRY_RESPONSE_GET_FAIL'
